// components/mobile/DetailRows.jsx
import React from 'react';
import { Empty } from 'antd';
import { ProductThumb } from './ProductThumb';
import { detailTargetFor, formatDate, integer, money } from '../../utils/mobileHelpers';
import { RightOutlined } from '@ant-design/icons';

export const DetailRows = ({ title, rows, domain, onOpen }) => (
  <section className="mobile-detail-subsection">
    <h3>{title}</h3>
    {rows?.length ? (
      <div className="mobile-detail-mini-list">
        {rows.map((row) => {
          const target = detailTargetFor(row);
          const key = `${target?.type || 'row'}-${target?.id || row.id_vente || row.id_detail || row.id_commande || row.event_id}-${row.date_vente || row.date_commande || row.occurred_at || ''}`;
          return (
            <button key={key} type="button" disabled={!target} onClick={() => target && onOpen(target.type, target.id)}>
              <ProductThumb domain={domain} image={row.img} title={row.nom_produit || row.label || title} />
              <span>
                <strong>{row.nom_produit || `Commande #${row.id_commande || row.detail_id || '—'}`}</strong>
                <small>{[row.couleur, row.taille ? `P${row.taille}` : null].filter(Boolean).join(' · ') || formatDate(row.date_vente || row.date_commande || row.occurred_at, true)}</small>
              </span>
              <b>{row.amount !== undefined ? money(row.amount) : `${integer(row.quantity || row.pairs || row.quantite)} paire(s)`}</b>
              {target && <RightOutlined />}
            </button>
          );
        })}
      </div>
    ) : (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Aucun élément associé" />
    )}
  </section>
);